import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  card={
    mainhead:'HR-Human Resource',
    subhead:'business Glossary',
    content:'A comprehensive HR Glossary providing an in-depth definition of all the important HR-related terms and business phrases used by Human resource professionals.'
    
  }

}
